import axios from "axios";
const { VUE_APP_SERVER, VUE_APP_PLATFORM_ID } = process.env;

const http = axios.create({
  baseURL: `${VUE_APP_SERVER}`,
  headers: {
    "Content-type": "application/json",
    "X-Platform-Id": VUE_APP_PLATFORM_ID,
  },
});

const verifyCode = (code) => {
  return http
    .get(`/pos/adopt/${code}`)
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const renewToken = (token) => {
  return http
    .get(`/pos/renew-token`, {
      headers: {
        "pos-authorization": `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const login = (token, body) => {
  return http
    .post(`/pos/login/operator`, body, {
      headers: {
        "pos-authorization": `Bearer ${token}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getAllParties = (tokenPair) => {
  return http
    .get(`/pos/party`, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const getTickets = (tokenPair, partyId) => {
  return http
    .get(`/pos/party/${partyId}/ticketGroups`, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const searchUser = async (tokenPair, partyId, query) => {
  return http
    .get(`/pos/party/${partyId}/user`, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
      params: {
        ...query,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const sell = async (tokenPair, partyId, body) => {
  return http
    .post(`/pos/party/${partyId}/sell`, body, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};
const sellKit = async (tokenPair, partyId, body) => {
  return http
    .post(`/pos/party/${partyId}/sellKit`, body, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const cancelPayment = async (tokenPair, paymentId) => {
  return http
    .delete(`/pos/payment/${paymentId}`, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const approvePayment = async (tokenPair, paymentId, body) => {
  return http
    .put(`/pos/payment/${paymentId}`, body, {
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPaymentTickets = (tokenPair, paymentId, sendMessage = false) => {
  return http
    .get(`/pos/payment/${paymentId}/tickets`, {
      params: {
        sendMessage,
      },
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getPaymentReport = (tokenPair, take = 15, page = 1) => {
  return http
    .get(`/pos/report/payment`, {
      params: {
        take,
        page,
      },
      headers: {
        authorization: `Bearer ${tokenPair.userToken}`,
        "pos-authorization": `Bearer ${tokenPair.posToken}`,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  verifyCode,
  renewToken,
  login,
  getAllParties,
  getTickets,
  searchUser,
  sell,
  sellKit,
  cancelPayment,
  approvePayment,
  getPaymentTickets,
  getPaymentReport,
};
